<template>
  <div :class="`customized-swiper swiper ${classNameType}`">
    <swiper class="swiper-wrapper" :options="swiperOption">
      <swiperSlide
        class="swiper-slide"
        v-for="(item, index) in contentData"
        :key="index"
      >
        <img
          :src="item.address"
          :class="`slide-image ${className}`"
          @click="$jump(item.link)"
        />
      </swiperSlide>
      <div
        class="swiper-pagination paginationBanner"
        slot="pagination"
        v-show="setData.showPoint"
      ></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import '@/assets/css/swiper.min.css'
export default {
  name: 'MySwiper',
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    contentData: {
      type: Array,
      default: () => [],
    },
    setData: {
      type: Object,
      default: () => {
        return {
          interval: 3000, // 轮播间隔 3000 5000
          showPoint: true, // 显示圆点 true false
          borderRadiusStyle: 'rightAng', // 图片边角 rightAng fillAng
          pageSpace: 'none', // 页边距 none has
          topSpace: 'small', // 上边距 small medium big
          bottomSpace: 'small', // 下边距 small medium big
        }
      },
    },
  },
  data: function () {
    return {
      classNameType: `pageSpace-${this.setData.pageSpace} topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
      className: `borderRadiusStyle-${this.setData.borderRadiusStyle}`,
      swiperOption: {
        pagination: {
          el: '.paginationBanner',
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: this.setData.interval,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
    }
  },
  mounted: function () {},
  methods: {},
}
</script>
<style lang="less" scoped>
.customized-swiper {
  width: 100%;
  box-sizing: border-box;
  .borderRadiusStyle-fillAng {
    border-radius: 10px;
  }
}
.pageSpace-has {
  padding: 0 10px;
}
.topSpace-medium {
  padding-top: 10px;
}
.topSpace-big {
  padding-top: 15px;
}
.bottomSpace-medium {
  padding-bottom: 10px;
}
.bottomSpace-big {
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/Swiper.vue